import _ from "lodash";
import axios from "axios";
import moment from "moment";
import "moment/locale/pt-br";



//RETORNA PARSE BILLING PAGARME
export function parserBilling(billingAddress) {
  let billing = {
    name: billingAddress.name,
    address: {
      country: "br",
      state: billingAddress.state.toLowerCase(),
      city: billingAddress.city,
      neighborhood: billingAddress.neighborhood,
      street: billingAddress.street,
      street_number: billingAddress.streetNumber,
      zipcode: billingAddress.zipCode.replace(/\D/g, ""),
    },
  };

  if (billingAddress.complementary && billingAddress.complementary !== "") {
    billing.address.complementary = billingAddress.complementary;
  }

  return billing;
}

//RETORNA PARSE CUSTOMER PAGARME
export function parserCustomer(user) {
  let phone = "+55";
  let phoneNumber = phone.concat(user.phone.replace(/\D/g, ""));

  let customer = {
    external_id: user._id,
    name: user.name,
    type: "individual",
    country: "br",
    email: user.email,
    documents: [
      {
        type: "cpf",
        number: user.cpf.replace(/\D/g, ""),
      },
    ],
    phone_numbers: [phoneNumber],
    birthday: moment(user.birthday).format("YYYY-MM-DD"),
  };

  return customer;
}

// RETURN PARSE DELIVERY ADDRESS PAGARME
export function parserShipping(accountAddress, shippingDelivery, user) {
  const deliveryDate = moment(shippingDelivery.dateEstimate).format(
    "YYYY-MM-DD"
  );

  let shipping = {
    name: user.name,
    fee: parseInt(shippingDelivery.tax.toString().replace(",", "")),
    delivery_date: deliveryDate,
    expedited: false,
    //shippingType: shippingDelivery.code,
    address: {
      country: "br",
      state: accountAddress.state.toLowerCase(),
      city: accountAddress.city,
      neighborhood: accountAddress.neighborhood,
      street: accountAddress.street,
      street_number: accountAddress.streetNumber,
      zipcode: accountAddress.zipCode.replace(/\D/g, ""),
    },
  };

  if (accountAddress.complementary && accountAddress.complementary !== "") {
    shipping.address.complementary = accountAddress.complementary;
  }

  return shipping;
}

//RETORNA PARSE PRODUCTS PAGARME
export function parserProducts(products) {
  let items = [];
  products.forEach((element) => {
    const price = element.ProductSalePrice
      ? element.ProductSalePrice
      : element.ProductPrice;
    let unitPrice = parseInt(price.toString().replace(",", "") * 100);

    let item = {
      id: element.ProductID,
      title: element.ProductName,
      unit_price: unitPrice,
      quantity: element.ProductQuantity,
      tangible: true,
    };
    items.push(item);
  });

  return items;
}

export function translateStatus(status) {
  switch (status) {
    case "processing":
      return "Em Análise";
    case "authorized":
      return "Em Análise";
    case "paid":
      return "Pago";
    case "refunded":
      return "Estornado";
    case "pending":
      return "Pendente";
    case "waiting_payment":
      return "Aguardando Pagamento";
    case "pending_refund":
      return "Aguardando Estorno";
    case "refused":
      return "Cancelada";
    case "chargedback":
      return "Em  Análise Manual";
    case "analyzing":
      return "Em Análise Manual";
    case "pending_review":
      return "Em Análise Manual";
    case "cancelled":
      return "Cancelada";
    case "pendent":
      return "Pendente";
    case "pendent_second":
          return "Pendente Segunda Parcela";
    default:
      return status;
  }
}

export function PaymentMethod(method) {
  switch (method) {
    case "boleto":
      return "Boleto";
    case "credit_card":
      return "Cartão de crédito";
    case "money":
       return "Dinheiro";
    case "pix":
        return "PIX";
    case "ted":
        return "TED";
    case "doc":
         return "DOC";
    case "debit_card":
          return "Cartão de Débito";
    case "not_applicable":
          return "Não se aplica";
    default:
      return method;
  }
}


  export function DeliveryType(method) {
    switch (method) {
      case "correios":
        return "Correios";
      case "motoboy":
        return "Motoboy";
      case "presencial":
         return "Presencial";
      case "jadlog":
          return "Jadlog";
      default:
        return method;
    }
  }

  export function SaleType(method) {
    switch (method) {
      case "casa22_rb_presencial":
        return "Venda Casa 22 - Ribeirão Preto";
        case "casa22_flag_presencial":
          return "Venda Casa 22 - Flagship";
      case "online":
        return "Online Manualmente";
      case "gift":
         return "Presente / Permuta";
      case "presencial":
          return "Venda presencial";
      case "returned":
            return "Devolvido";
      case "borrowed":
             return "Emprestado";
      case "caixa":
            return "Venda Balcão";
      default:
        return 'Online pelo Site';
    }
  }

  export function translateDictionary(key){
    let dictionary = {
      JUMPSUIT: "MACACÃO",
      DRESS: "VESTIDO",
      BERMUDA: "BERMUDA",
      SHORT: "SHORT",
      BLAZER: "BLAZER",
      TOP: "TOP",
      PANTS: "CALÇA",
      SHIRT: "BLUSA"
    };
    return dictionary[key];
  }
  
  export function CategoryName(product) {

    if(product.ProductCategory){
      return translateDictionary(product.ProductCategory.toUpperCase());
    }else if (product.ProductID && product.ProductID.category){
      return  translateDictionary(product.ProductID.category.toUpperCase());
    }else 
      return "";
  }


